import { Heading, Text } from '@betterment/samba-react';

import { urlBuilder } from '~/b4b/utils/urlBuilder';

import { ErrorContent } from '../error-content/ErrorContent';
import { SambaAutoLink } from '../SambaAutoLink';

const PartialErrorFallback = () => {
  return (
    <ErrorContent>
      <ErrorContent.Header>
        <Heading as="h1">Unable to complete request</Heading>
      </ErrorContent.Header>
      <ErrorContent.Description>
        <Text>
          We're sorry, we're working to resolve this issue. Please try again later. If the issue continues,{' '}
          <SambaAutoLink to={urlBuilder.support()}>contact us</SambaAutoLink>.
        </Text>
      </ErrorContent.Description>
    </ErrorContent>
  );
};

export default PartialErrorFallback;
